module.exports = __webpack_public_path__ + "img/20191119163717749.5c30015a.jpg";